import React, { useEffect, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import './HomePage.css'
import { useAuth } from '../../modules/auth'
import axios from 'axios'
import { Expediente } from '../../components/Expediente/Expediente'
import ReactPaginate from 'react-paginate'
import PlanHeader from '../../components/PlanHeader/PlanHeader'

function HomePage() {
  const API_URL = process.env.REACT_APP_API_URL
  const fecha = new Date()
  const { currentUser } = useAuth()

  const [loadingPage, setLoadingPage] = useState(false)
  const [fechaLastUpdate, setFechaLastUpdate] = useState(new Date())
  const [currentView, setCurrentView] = useState(1)

  const [expedientes, setExpedientes] = useState([])      // boletín
  const [misExpedientes, setMisExpedientes] = useState([]) // expedientes del plan
  const [searchValue, setSearchValue] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [recordsPerPage] = useState(10)

  // ─── FUNCIONES DE EXPEDIENTES ───
  const dayNotifications = () => {
    setLoadingPage(true)
    axios.get(`${API_URL}/app/dayNotifications/${currentUser.id}`)
      .then(res => {
        setExpedientes(Array.isArray(res.data) ? res.data : [])
        setLoadingPage(false)
        setCurrentView(1)
      })
      .catch(() => setLoadingPage(false))
  }

  const weekNotifications = () => {
    setLoadingPage(true)
    axios.get(`${API_URL}/app/weekNotifications/${currentUser.id}`)
      .then(res => {
        setExpedientes(Array.isArray(res.data) ? res.data : [])
        setLoadingPage(false)
        setCurrentView(2)
      })
      .catch(() => setLoadingPage(false))
  }

  const cargarMisExpedientes = () => {
    axios.get(`${API_URL}/app/expedientes/${currentUser.id}`)
      .then(res => setMisExpedientes(Array.isArray(res.data) ? res.data : []))
      .catch(() => setMisExpedientes([]))
  }

  const getLastUpdate = () => {
    axios.get(`${API_URL}/app/lastUpdate/`)
      .then(res => {
        const t = res.data[0]?.lastUpdateTimestamp?.split(/[- :]/) || []
        if (t.length === 6) setFechaLastUpdate(new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]))
      })
      .catch(() => {})
  }

  // ─── FILTRO ───
  const searchedExpedientes = Array.isArray(expedientes)
    ? expedientes.filter(exp => exp.expediente?.includes(searchValue))
    : []

  const indexOfLastRecord = currentPage * recordsPerPage
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
  const currentRecords = searchedExpedientes.slice(indexOfFirstRecord, indexOfLastRecord)

  const paginate = ({ selected }) => setCurrentPage(selected + 1)

  // ─── FECHA ───
  const addZero = i => i < 10 ? '0' + i : i
  const formatoFecha = (fecha, formato) => {
    const meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre']
    const map = {
      dd: fecha.getDate(),
      mm: meses[fecha.getMonth()],
      yyyy: fecha.getFullYear(),
      HH: addZero(fecha.getHours()),
      MM: addZero(fecha.getMinutes())
    }
    return formato.replace(/mm|dd|HH|MM|yyyy/gi, m => map[m])
  }

  // ─── CARGA INICIAL ───
  useEffect(() => {
    getLastUpdate()
    dayNotifications()
    cargarMisExpedientes()
  }, [])

  return (
    <>
      {/* HEADER con PlanHeader */}
      <PlanHeader
        totalExpedientes={misExpedientes?.length || 0}
        onRefresh={() => {
          cargarMisExpedientes()
          dayNotifications()
        }}
      />

      {/* Card container */}
      <div className='row gy-5 g-xl-8 card card-custom shadow mt-4 pb-10'>
        <div className='row p-6 pb-15'>
          <div className='col-md-6'>
            <h4>Boletín del día</h4>
            <li className='d-flex align-items-center py-2'>
              <span className='bullet bullet-dot bg-success h-15px w-15px me-5'></span>
              <b>Última conexión al boletín:&nbsp;</b>
              {formatoFecha(fechaLastUpdate, 'dd de mm yyyy - HH:MM hrs')}
            </li>
          </div>

          <div className='col-md-6 text-right'>
            <button
              type='button'
              className={`btn float-end btn-sm w-60 m-1 ${currentView === 2 ? 'btn-dia' : 'btn-light'}`}
              onClick={weekNotifications}
            >
              Últimos 7 días
            </button>
            <button
              type='button'
              className={`btn float-end btn-sm w-60 m-1 ${currentView === 1 ? 'btn-dia' : 'btn-light'}`}
              onClick={dayNotifications}
            >
              Del día
            </button>

            <div className='form-group float-end pt-3'>
              <KTSVG path='/media/icons/duotune/general/gen021.svg' className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 ms-0' />
              <input
                type='text'
                className='form-control form-control-flush ps-10 inicio-search-box mt-n10 mr-10'
                placeholder='Buscar expediente...'
                value={searchValue}
                onChange={e => { setSearchValue(e.target.value); setCurrentPage(1) }}
              />
            </div>
          </div>
        </div>

        {/* Exp container */}
        <div className='row mb-10'>
          {!loadingPage ? <Expediente expedientes={currentRecords} /> :
            <div className='d-flex flex-center'>
              <h2>
                <span className='spinner-border spinner-border align-middle ms-2'></span>
                Cargando...
              </h2>
            </div>
          }
        </div>

        <div className='row text-center'>
          <p>Mostrando {currentRecords.length} de {searchedExpedientes.length} resultados</p>
        </div>

        <ReactPaginate
          onPageChange={paginate}
          pageCount={Math.ceil(searchedExpedientes.length / recordsPerPage)}
          breakLabel={'...'}
          previousLabel={'< Anterior'}
          nextLabel={'Siguiente >'}
          containerClassName={'pagination'}
          pageLinkClassName={'page-number'}
          previousLinkClassName={'page-number'}
          nextLinkClassName={'page-number'}
          activeLinkClassName={'active'}
          forcePage={currentPage - 1}
        />
      </div>
    </>
  )
}

export { HomePage }